// src/pages/Milestones.js
import React from 'react';
import './milestones.css';

const milestones = [
  {
    "date": "1910 ഏപ്രിൽ 16",
    "title": "ബാലപംക്തിക്ക് തുടക്കം",
    "description": "മലയാള മനോരമയിൽ ബാലപംക്തിക്കു തുടക്കം. ‘കൊച്ചേട്ടൻ’ എന്ന തൂലികാനാമത്തിൽ പത്രാധിപർ കെ.സി. മാമ്മൻ മാപ്പിള കുട്ടികൾക്കായി എഴുതുന്നു."
  },
  {
    "date": "1929 മേയ് 29",
    "title": "അഖിലകേരള ബാലജനസഖ്യം ആരംഭം",
    "description": "ബാലപംക്തി തുടങ്ങി 19 വർഷങ്ങൾക്കു ശേഷം അഖിലകേരള ബാലജനസഖ്യം ആരംഭിച്ചു. ഈശ്വര ഭക്തി, രാജ്യസ്നേഹം, പൊതുജന സേവനം എന്നതാണു മുഖമുദ്ര. സഖ്യത്തിനു മുദ്രാവാക്യം എഴുതാൻ കുട്ടികളോട് അഭ്യർഥിച്ചു. WE SERVE തിരഞ്ഞെടുക്കപ്പെട്ടു."
  },
  {
    "date": "1931 ഏപ്രിൽ",
    "title": "ജാതീയതയ്ക്ക് എതിരെ സഖ്യം",
    "description": "സഖ്യത്തിന്റെ നേതൃത്വത്തിൽ മിശ്രഭോജനം. പ്രതീകാത്മകമായി ജാതിപ്പിശാചിന്റെ കോലം കത്തിക്കൽ."
  },
  {
    "date": "1934 ജനുവരി",
    "title": "ഗാന്ധിജിയുമായി കൂടിക്കാഴ്ച",
    "description": "കേരളത്തിലെത്തിയ മഹാത്മാ ഗാന്ധിയെ സഖ്യം പ്രതിനിധികൾ സന്ദർശിക്കുന്നു. സേവനപ്രവർത്തനങ്ങളിൽ ശ്രദ്ധയൂന്നാൻ ഗാന്ധിജിയുടെ ഉപദേശം. അതേ വർഷം കുട്ടികൾക്കായി ദ്രുതകവന മത്സരം. വിഷയം നിർദേശിച്ചതു മഹാകവി വള്ളത്തോൾ."
  },
  {
    "date": "1938 സെപ്റ്റംബർ 10",
    "title": "മലയാള മനോരമ മുദ്രവയ്ക്കൽ",
    "description": "ദിവാൻ സിപി രാമസ്വാമി അയ്യരുടെ പൊലീസ് മലയാള മനോരമ മുദ്രവയ്ക്കുന്നു. സഖ്യം പ്രവർത്തനം നിലച്ചു. 9 വർഷത്തിനുശേഷം മനോരമയുടെ ഉയിർത്തെഴുന്നേൽപ്."
  },
  {
    "date": "1948 ജനുവരി 28",
    "title": "ബാലപംക്തി പുനഃപ്രസിദ്ധീകരണം",
    "description": "ബാലപംക്തി വീണ്ടും പ്രസിദ്ധീകരിച്ചുതുടങ്ങുന്നു."
  },
  {
    "date": "1954 മേയ് 22",
    "title": "രജതജൂബിലി ആഘോഷം",
    "description": "രജതജൂബിലി ആഘോഷം കോട്ടയത്ത്. ഉദ്ഘാടനം ചെയ്തത് സർദാർ കെ. എം. പണിക്കർ. കേന്ദ്രമന്ത്രി പനമ്പിളളി ഗോവിന്ദമേനോൻ അധ്യക്ഷനായി."
  },
  {
    "date": "1978 സെപ്റ്റംബർ 9",
    "title": "നിർധനർക്കു വീട് പദ്ധതി",
    "description": "നിർധനർക്കു വീടു നൽകുന്ന പദ്ധതിക്കു മല്ലപ്പള്ളിയിൽ തുടക്കം. മുഖ്യമന്ത്രി എ. കെ. ആന്റണി താക്കോൽ സമർപ്പിച്ചു."
  },
  {
    "date": "1981 ജനുവരി 4",
    "title": "എൻഡോവ്മെന്റ് പ്രസംഗ മത്സരം",
    "description": "ഡോ. പി.സി. അലക്സാണ്ടർ എൻഡോവ്മെന്റ് സംസ്ഥാനതല പ്രസംഗമത്സരത്തിനു മാവേലിക്കരയിൽ തുടക്കം."
  },
  {
    "date": "1982 ജനുവരി 31",
    "title": "സഖ്യം കനകജൂബിലി",
    "description": "കൊച്ചിയിൽ സഖ്യം കനകജൂബിലി ആഘോഷം. രാഷ്ട്രപതി എൻ. സഞ്ജീവ റെഡ്ഡി ഉദ്ഘാടകൻ."
  },
  {
    "date": "1990 മേയ് 29",
    "title": "വജ്രജൂബിലി വർഷം",
    "description": "കോട്ടയം കുറിച്ചി പാപ്പാൻചിറ പുത്തൻകോളനിയിലും പാമ്പാക്കുട പഞ്ചായത്തിലെ ആൽപാറ ലക്ഷം വീട് കോളനിയിലും വയനാട്ടിലെ കുപ്പക്കൊല്ലിയിലും വജ്രജൂബിലി സ്മാരക കമ്യൂണിറ്റി ഹാളുകൾക്കു ശിലയിട്ടു."
  },
  {
    "date": "2002 നവംബർ 17",
    "title": "എ.പി.ജെ. അബ്ദുൽ കലാമുമായി സംവാദം",
    "description": "രാഷ്ട്രപതി എ.പി.ജെ. അബ്ദുൽ കലാമുമായി ‘എന്റെ സ്വപ്നത്തിലെ ഇന്ത്യ’ എന്ന വിഷയത്തിൽ സഖ്യം പ്രതിനിധികളുടെ സംവാദം. സഖ്യത്തിന്റെ വെബ്സൈറ്റ് അദ്ദേഹം ഉദ്ഘാടനം ചെയ്തു."
  },
  {
    "date": "2004 സെപ്റ്റംബർ 5",
    "title": "ഹൃദയപൂർവം സഖ്യം പദ്ധതി",
    "description": "പ്ലാറ്റിനം ജൂബിലി ആഘോഷത്തിന്റെ ഭാഗമായി ‘ഹൃദയപൂർവം സഖ്യം’ പദ്ധതി. മദ്രാസ് മെഡിക്കൽ മിഷൻ ആശുപത്രിയുടെ പിന്തുണയോടെ 2010 വരെ 450 കുഞ്ഞുങ്ങൾക്കു ഹൃദയശസ്ത്രക്രിയ."
  },
  {
    "date": "2019 ഫെബ്രുവരി 2",
    "title": "സഖ്യം നവതി ആഘോഷം",
    "description": "സഖ്യം നവതി ആഘോഷം ഉദ്ഘാടനം ഉപരാഷ്ട്രപതി വെങ്കയ്യ നായിഡു നിർവഹിച്ചു."
  }
];

function Milestones() {
  return (
    <div className="milestones-page">
      <h1>MILESTONES</h1>
      <div className="milestones-container">
        {milestones.map((milestone, index) => (
          <div key={index} className="milestone-card">
            <div className="milestone-content">
              <h2>{milestone.date}</h2>
              <h3>{milestone.title}</h3>
              <p>{milestone.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Milestones;
